// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast,
.Toastify__toast-body {
  padding: 0;
  border-radius: 16px;
  width: max-content;
}

.Toastify__toast-icon,
.Toastify__close-button {
  display: none;
}

.success-toast {
  display: inline-flex;
  padding: 16px 28px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  border: 1px solid var(--Color-Border-Stroke, #d8e3f4);
  background: var(--Vlearn-new-design-Gradient-2, linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%));
  box-shadow: 0px 0px 12px 0px rgba(51, 59, 72, 0.1);
}
.success-toast__illustration {
  display: flex;
  justify-content: center;
  align-items: center;
}
.success-toast__content-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.success-toast__header {
  color: var(--Colors-Indicator-Greens-300, #3c9455);
  text-align: center;
  font-family: "Semi Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}
.success-toast__content {
  color: var(--Color-Text-Tertiary, #5d6c83);
  text-align: center;
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
}

.error {
  color: #ef5054;
  background: var(--Vlearn-new-design-Gradient-3, linear-gradient(93deg, #ffefd7 -3.6%, #ffc2c2 97.6%));
}

.warning {
  background: linear-gradient(93deg, #FFFAC9 -3.6%, #FFDFA1 97.6%);
  color: #CB9100;
}`, "",{"version":3,"sources":["webpack://./src/@common/SuccessToast/successToast.scss"],"names":[],"mappings":"AAAA;;EAEE,UAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,aAAA;AACF;;AAEA;EACE,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qDAAA;EACA,uGAAA;EAIA,kDAAA;AAFF;AAIE;EACE,aAAA;EAGA,uBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AALJ;AAQE;EACE,kDAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AASE;EACE,0CAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,cAAA;EACA,qGAAA;AARF;;AAcA;EACE,gEAAA;EACA,cAAA;AAXF","sourcesContent":[".Toastify__toast,\n.Toastify__toast-body {\n  padding: 0;\n  border-radius: 16px;\n  width: max-content;\n}\n\n.Toastify__toast-icon,\n.Toastify__close-button {\n  display: none;\n}\n\n.success-toast {\n  display: inline-flex;\n  padding: 16px 28px;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  border: 1px solid var(--Color-Border-Stroke, #d8e3f4);\n  background: var(\n    --Vlearn-new-design-Gradient-2,\n    linear-gradient(114deg, #d0f9d7 3.61%, #eaf2b1 97.06%)\n  );\n  box-shadow: 0px 0px 12px 0px rgba(51, 59, 72, 0.1);\n\n  &__illustration {\n    display: flex;\n    // width: 80px;\n    // height: 44px;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__content-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  &__header {\n    color: var(--Colors-Indicator-Greens-300, #3c9455);\n    text-align: center;\n    font-family: 'Semi Sans';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 100%;\n  }\n\n  &__content {\n    color: var(--Color-Text-Tertiary, #5d6c83);\n    text-align: center;\n    font-family: 'Medium Sans';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 140%;\n  }\n}\n\n.error {\n  color: #ef5054;\n  background: var(\n    --Vlearn-new-design-Gradient-3,\n    linear-gradient(93deg, #ffefd7 -3.6%, #ffc2c2 97.6%)\n  );\n}\n\n.warning {\n  background: linear-gradient(93deg, #FFFAC9 -3.6%, #FFDFA1 97.6%);\n  color: #CB9100;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
